import React from "react";

const darkParticles = [
  { left: "8%", top: "18%", delay: "0s", duration: "14s", size: 4 },
  { left: "22%", top: "72%", delay: "2s", duration: "18s", size: 3 },
  { left: "38%", top: "42%", delay: "4s", duration: "16s", size: 5 },
  { left: "55%", top: "28%", delay: "1s", duration: "20s", size: 3 },
  { left: "68%", top: "65%", delay: "3s", duration: "15s", size: 4 },
  { left: "82%", top: "38%", delay: "5s", duration: "17s", size: 3 },
  { left: "92%", top: "78%", delay: "2.5s", duration: "19s", size: 4 },
  { left: "15%", top: "88%", delay: "6s", duration: "21s", size: 3 },
  { left: "48%", top: "8%", delay: "1.5s", duration: "13s", size: 4 },
  { left: "74%", top: "12%", delay: "3.5s", duration: "16s", size: 3 }
];

const lightParticles = [
  { left: "10%", top: "15%", delay: "0s", duration: "16s", size: 5 },
  { left: "85%", top: "20%", delay: "2s", duration: "19s", size: 4 },
  { left: "72%", top: "75%", delay: "4s", duration: "17s", size: 5 },
  { left: "18%", top: "68%", delay: "1s", duration: "20s", size: 4 },
  { left: "45%", top: "88%", delay: "3s", duration: "18s", size: 3 },
  { left: "58%", top: "12%", delay: "5s", duration: "15s", size: 4 }
];

export function LoginDarkBackground() {
  return (
    <div className="login-bg login-bg-dark" aria-hidden>
      <div className="login-bg-gradient login-bg-gradient-dark" />
      <div className="login-bg-grid login-bg-grid-dark" />
      <div className="login-bg-orb login-bg-orb-dark-1" />
      <div className="login-bg-orb login-bg-orb-dark-2" />
      <div className="login-bg-orb login-bg-orb-dark-3" />
      <div className="login-bg-shimmer login-bg-shimmer-dark" />
      {darkParticles.map((particle, index) => (
        <span
          key={index}
          className="login-bg-particle login-bg-particle-dark"
          style={{
            left: particle.left,
            top: particle.top,
            width: particle.size,
            height: particle.size,
            animationDelay: particle.delay,
            animationDuration: particle.duration
          }}
        />
      ))}
    </div>
  );
}

export function LoginLightBackground() {
  return (
    <div className="login-bg login-bg-light" aria-hidden>
      <div className="login-bg-gradient login-bg-gradient-light" />
      <div className="login-bg-orb login-bg-orb-light-1" />
      <div className="login-bg-orb login-bg-orb-light-2" />
      <div className="login-bg-orb login-bg-orb-light-3" />
      <div className="login-bg-ring login-bg-ring-1" />
      <div className="login-bg-ring login-bg-ring-2" />
      {lightParticles.map((particle, index) => (
        <span
          key={index}
          className="login-bg-particle login-bg-particle-light"
          style={{
            left: particle.left,
            top: particle.top,
            width: particle.size,
            height: particle.size,
            animationDelay: particle.delay,
            animationDuration: particle.duration
          }}
        />
      ))}
    </div>
  );
}
